import React from "react";
import { FormattedMessage as FM } from "react-intl";
import { Container, Header, Icon, Placeholder } from "semantic-ui-react";

import PageWrapperTwoColumns from "./PageWrapperTwoColumns";

interface INotFoundPageProps {
    construction?: boolean;
}

const NotFoundPage: React.FC<INotFoundPageProps> = (props: INotFoundPageProps) => {
    const { construction } = props;

    return (
        <PageWrapperTwoColumns>
            <Header as="h1">404</Header>
            <Container>
                {!construction ? (
                    <Header as="h1">
                        <FM id="error.404" />
                    </Header>
                ) : (
                    <div style={{ marginBottom: "5vh" }}>
                        <Header as="h1">
                            <FM id="error.construction" />
                        </Header>
                        <Icon color="violet" name="road" size="large" />
                        <Icon color="violet" name="ban" size="large" />
                        <Icon color="violet" name="map signs" size="large" />
                        <Icon color="violet" name="angle double right" size="large" />
                        <Icon color="violet" name="exchange" size="large" />
                        <Icon color="violet" name="bullhorn" size="large" />
                        <Icon color="violet" name="calendar" size="large" />
                        <Icon color="violet" name="info" size="large" />
                        <Icon color="violet" name="wrench" size="large" />
                        <Icon color="violet" name="cog" size="large" />
                        <Icon color="violet" name="cogs" size="large" />
                        <Icon color="violet" name="coffee" size="large" />
                        <Icon color="violet" name="tasks" size="large" />
                        <Icon color="violet" name="code" size="large" />
                        <Icon color="violet" name="sitemap" size="large" />
                        <Icon color="violet" name="puzzle piece" size="large" />
                        <Icon color="violet" name="question circle" size="large" />
                        <Icon color="violet" name="user secret" size="large" />
                        <Icon color="violet" name="eye slash" size="large" />
                        <Icon color="violet" name="lock" size="large" />
                    </div>
                )}
                <Placeholder fluid>
                    <Placeholder.Paragraph>
                        <Placeholder.Line />
                        <Placeholder.Line />
                        <Placeholder.Line />
                    </Placeholder.Paragraph>
                </Placeholder>
            </Container>
        </PageWrapperTwoColumns>
    );
};

export default NotFoundPage;
